import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'

export default class Label extends React.Component {
    render(){
        return (
            <Flex className={style.SubLabel} onClick={this.props.onClick} width='100%' center {...this.props}>
                {this.props.children}
            </Flex>
        )
    }

}



// WEBPACK FOOTER //
// ./src/component/Label/SubLabel.js